import { FormikProps } from 'formik';
import React from 'react';
import { FormField } from '../../../../../../global/components/form-element/form-field';
import { NumberField, NumberInputTypes } from '../../../../../../global/components/form-element/number-field';
import { ContributionAmountType, LayDcPlanFormModel } from '../models/plan-adoption-form-models';


interface Props {
    labelText: string;
    formProps: FormikProps<LayDcPlanFormModel>,
    amountTypePropertyName: string;
    amountPropertyName: string;
    percentagePropertyName: string;
    contributionAmountTypeOptions: { label: string, value: string }[],
    hasTypeSelector?: boolean;
    isRequired?: boolean;
}

function ContributionAmountField(props: Props) {

    const { formProps, labelText, amountTypePropertyName, percentagePropertyName, amountPropertyName, contributionAmountTypeOptions, hasTypeSelector, isRequired } = props;

    const matchContributionAmountType = formProps.values[amountTypePropertyName];

    function renderContributionTypeSelector() {
        if (!hasTypeSelector) return null;

        return (
            <FormField
                name={`${amountTypePropertyName}`}
                component='radioGroup'
                options={contributionAmountTypeOptions}
                touched={formProps.touched}
                errors={formProps.errors}
                required={isRequired}
            />
        );
    }

    function renderContributionValue() {
        if (matchContributionAmountType === ContributionAmountType.Percentage) {
            return <NumberField
                name={`${percentagePropertyName}`}
                label=''
                type={NumberInputTypes.PercentageInteger}
                formikProps={formProps}
                required={isRequired}
            />;
        }

        if (matchContributionAmountType === ContributionAmountType.Dollar) {
            return <NumberField
                name={`${amountPropertyName}`}
                label=''
                type={NumberInputTypes.Currency}
                formikProps={formProps}
                required={isRequired}
            />;
        }

        return <NumberField
            name={`${amountPropertyName}`}
            label=''
            type={NumberInputTypes.Integer}
            formikProps={formProps}
            required={isRequired}
            disabled
        />;
    }

    return <>

        {
            hasTypeSelector &&
            <div className='form-item'>
                <h4>{labelText}</h4>
                <div>
                    {renderContributionTypeSelector()}
                </div>
                {renderContributionValue()}
            </div>
        }
        {
            !hasTypeSelector &&
            <NumberField
                name={`${percentagePropertyName}`}
                label={labelText}
                type={NumberInputTypes.PercentageInteger}
                formikProps={formProps}
                required={isRequired}
            />
        }
    </>;
}

ContributionAmountField.defaultProps = {
    hasTypeSelector: false,
    isRequired: false,
};

export default ContributionAmountField;